import { render, staticRenderFns } from "./spermsMorphologyOfRegularBulls.vue?vue&type=template&id=72797d78&scoped=true&"
import script from "./spermsMorphologyOfRegularBulls.vue?vue&type=script&lang=js&"
export * from "./spermsMorphologyOfRegularBulls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72797d78",
  null
  
)

export default component.exports